import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  qrCodeImage: (props: { size?: string }) => ({
    width: props.size ? props.size : 116,
    height: props.size ? props.size : 116,

    // Print view
    '@media print': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      width: '300px',
      height: '300px',
    },
  }),
}))

export default useStyles
